import React, {useRef} from 'react';
import Box from "@mui/material/Box";
import {handleLogout as doLogout} from "../index";
import {Link as LinkUI, useNavigate } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Avatar, Button, Container, Grid, Paper, Stack, Typography} from "@mui/material";
import {ErrorContainer} from "../../../../Components";
import { styled } from "@mui/material/styles";

const Link = styled(LinkUI)(({ theme }) => ({
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontSize: '1.2rem',
    '&:hover': {
        cursor: 'pointer',
        color: theme.palette.primary.dark,
    },
}));

export const Error403 = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector(store => store.auth);
    const hasLoggedOut = useRef(false);
    const tenant = useSelector(store => store.app.tenant);

    const handleLogout = () => {
        if (auth.isLoggedIn && !hasLoggedOut.current) {
            hasLoggedOut.current = true;
            doLogout(dispatch);
        }
        navigate(`/login`);
    }

    return (
        <Box width={"100%"} justifyContent={"center"} alignContent={"center"} sx={{background:'#f8f8f8'}}>
            <ErrorContainer className={"login-section"} maxWidth={"xxl"} component={"section"}>
                <Container maxWidth={"lg"}>
                    <Paper>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Link to="/">
                                    <Avatar variant={"square"} src={tenant?.avatar_url ? tenant?.avatar_url : '/images/favicon/adnec-favicon-color.png'} height={60} alt={"Logo"} />
                                </Link>
                            </Grid>
                            <Grid className={"left"} item xs={12} md={8}>
                                <Typography className={"title"} variant={"h1"}>{tenant?.name}</Typography>
                                <Typography className={"description"} variant={"body1"}>You do not have access to this domain.</Typography>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>

                                    </Grid>
                                    <Grid item xs={12}>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <Stack justifyContent={"right"} direction={"row"}>
                                            <Button
                                                color="primary"
                                                className={'text-capitalize'}
                                                variant="contained"
                                                onClick={() => handleLogout()}
                                            >
                                                Logout
                                            </Button>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Box className={"footer"} mt={3}>
                        <Grid container spacing={2}>
                            <Stack justifyContent={"space-between"} direction={"row"}>
                                <Typography variant={"body1"}>Forgot your password? <Link to="/forgot-password">Recover</Link></Typography>
                            </Stack>
                        </Grid>
                    </Box>
                </Container>
            </ErrorContainer>
        </Box>
    )
}